/* CANFOTO V67BS-R14 — risk evidence adjudication, shadow only.
   Never treats watt candidate as photometric proof; NEVER changes rank, score, F/P or UI. */
(function(W){'use strict';
 const VERSION='CANFOTO-NORA-R14-RISK-ADJUDICATION-V1';
 const LANES=['BARE_LIGHT','SINGLE_READY_SET'];
 const PROVISIONAL='PROVISIONAL_LEGACY_COPY_NOT_CERTIFIED';
 function classifyRecord(key,lane,rank,row,cap,e,meta){
  const reasons=[];
  if(meta?.contractStatus===PROVISIONAL) reasons.push('SEMANTIC_CONTRACT_PENDING');
  if(!cap)reasons.push('R2G_CAPABILITY_MISSING');
  if(e.status==='MAIN_ROLE_NOT_ELIGIBLE')reasons.push('R2G_MAIN_LIGHT_NOT_ELIGIBLE');
  if(e.capacityScreen==='BELOW_CANDIDATE_MIN')reasons.push('BELOW_UNCERTIFIED_WATT_SCREEN');
  if(e.status==='UNKNOWN')reasons.push('R2G_ROLE_UNKNOWN');
  const nonMain=e.status==='NON_MAIN_ROLE';
  const priority=reasons.includes('R2G_MAIN_LIGHT_NOT_ELIGIBLE')?'ROLE_CONFLICT_REVIEW':reasons.includes('SEMANTIC_CONTRACT_PENDING')?'SEMANTIC_REVIEW':reasons.includes('BELOW_UNCERTIFIED_WATT_SCREEN')?'POWER_CANDIDATE_REVIEW':nonMain?'NON_MAIN_ROLE_CONTEXT':'SOURCE_OBSERVATION';
  return {key,lane,rank,handle:row?.handle||null,sourceHandle:cap?.technicalSourceHandle||null,role:e.role||null,area:e.area||null,mainKeyEligible:cap?.mainKeyEligible??null,effectiveWhitePowerW:e.effectiveWhitePowerW??null,candidateMinimumW:e.minCandidateW??null,candidateIdealW:e.idealCandidateW??null,roleResult:e.status||null,semanticStatus:e.semanticStatus||null,capacityScreen:e.capacityScreen||null,priority,reviewReasons:reasons,photometricVerdict:'UNKNOWN',decision:'NO_AUTOMATIC_EXCLUSION'};
 }
 async function audit(){
  const p=W.GDX_PANEL_V4_R2D_EXACT_SELECTION_SCORE_PROJECTION;
  const owner=W.GDX_PANEL_V4_R2G_EFFECTIVE_POWER_ROLE_TRUTH;
  const r12=W.CANFOTO_NORA_PANEL_R2G_ROLE_BRIDGE_V67BS_R12;
  const r11=W.CANFOTO_NORA_PANEL_NATIVE_FIT_V67BS_R11;
  const r13=W.CANFOTO_NORA_PANEL_TOP3_RISK_V67BS_R13;
  if(typeof p?.getRowsAsync!=='function'||typeof p?.getRows!=='function'||typeof owner?.getCapability!=='function'||typeof r12?.classify!=='function'||!Array.isArray(r11?.keys)||typeof r13?.audit!=='function')throw Error('HOLD_REQUIRED_CANONICAL_OWNERS');
  const first=await r13.audit();
  if(first.status!=='PASS_EVIDENCE_ONLY_WITH_TECHNICAL_HOLD')throw Error('HOLD_R13_EVIDENCE');
  let parity=true,rowsCount=0,top3Count=0,top5Count=0,missing=0;
  const totals={ROLE_CONFLICT_REVIEW:0,SEMANTIC_REVIEW:0,POWER_CANDIDATE_REVIEW:0,NON_MAIN_ROLE_CONTEXT:0,SOURCE_OBSERVATION:0};
  const cases=[],caseGroups=[];
  for(const key of r11.keys)for(const lane of LANES){
   const rows=await p.getRowsAsync(key,{lane,limit:0});
   if(JSON.stringify(rows)!==JSON.stringify(p.getRows(key,{lane,limit:0})))parity=false;
   rowsCount+=rows.length;const group=[];
   for(let i=0;i<Math.min(rows.length,5);i++){
    const handle=rows[i]?.handle||p.rowHandle?.(rows[i])||null;
    const cap=handle?owner.getCapability(handle,key):null;
    if(!cap)missing++;
    const e=r12.classify(cap,key);
    const item=classifyRecord(key,lane,i+1,{handle},cap,e,r11.metadata[key]);
    cases.push(item);group.push(item);totals[item.priority]++;
    if(i<3)top3Count++;top5Count++;
   }
   caseGroups.push({key,lane,top5:group});
  }
  const severe=cases.filter(x=>x.priority==='ROLE_CONFLICT_REVIEW');
  const result={task:'V67BS_R14_EVIDENCE_ADJUDICATION',version:VERSION,mode:'READ_ONLY_SHADOW',selectionCount:r11.keys.length,laneCount:2,rowsCount,top3Count,top5Count,sourceParity:parity,missingCapabilities:missing,priorityCounts:totals,roleConflictCases:severe,provisionalKeys:r13?first.provisionalNativeKeys:[],caseGroups,photometryCertified:false,scoreMutation:false,rankMutation:false,fpCurveMutation:false};
  result.status=parity&&missing===0&&rowsCount===first.totals.rows&&top3Count===first.totals.top3Entries&&top5Count===first.totals.top5Entries?'PASS_EVIDENCE_ADJUDICATION_WITH_TECHNICAL_HOLD':'HOLD';
  return result;
 }
 W.CANFOTO_NORA_PANEL_RISK_ADJUDICATION_V67BS_R14=Object.freeze({version:VERSION,audit,scoreMutation:false,rankMutation:false,fpCurveMutation:false});
})(window);
